import ReactDOM from 'react-dom';

// third party
import {BrowserRouter} from 'react-router-dom';
import {Provider} from 'react-redux';

// project imports
import App from 'App';
import store from 'app/store';
import {ConfigCatProvider, PollingMode, createConsoleLogger, LogLevel} from 'configcat-react';
import config from 'config';

// style + assets
import 'assets/scss/style.scss';

// 2025.15.0 Release
const takedaConfigCatBaseUrl = 'https://takeda-cdn.configcat.com';
// ==============================|| REACT DOM RENDER  ||============================== //

ReactDOM.render(
  <Provider store={store}>
    <BrowserRouter>
      <ConfigCatProvider
        sdkKey={config.configCat.sdkKey}
        pollingMode={PollingMode.AutoPoll}
        options={{baseUrl: takedaConfigCatBaseUrl, pollIntervalSeconds: 30, logger: createConsoleLogger(LogLevel.Info)}}
      >
        <App />
      </ConfigCatProvider>
    </BrowserRouter>
  </Provider>,
  document.getElementById('root'),
);
